// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__53Vlg","content":"Table_content__3FWMJ"};